import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Center, Text, Icon } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FiVideoOff } from 'react-icons/fi';
import ReactPlayer from 'react-player';
import CobraSpinner from './CobraSpinner';

const MotionBox = motion(Box);

const VideoPlayer = ({ src, video, style }) => {
  const rawUrl = src || (video && video.url);
  const baseUrl = 'https://api.cobra-education.com';
  
  let videoUrl = rawUrl;
  if (rawUrl) {
    if (rawUrl.startsWith('/uploads')) {
      videoUrl = `${baseUrl}${rawUrl}`;
    } else if (rawUrl.startsWith('uploads/')) {
      videoUrl = `${baseUrl}/${rawUrl}`;
    }
  }
  
  const [isReady, setIsReady] = useState(false);

  return (
    <MotionBox
      width="100%"
      height={style?.height || "100%"}
      minHeight={{ base: "250px", md: "450px" }}
      mx="auto"
      dir="rtl"
      onContextMenu={(e) => e.preventDefault()}
      position="relative"
      borderRadius="2xl"
      overflow="hidden"
      bg="black"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      boxShadow="0 10px 30px -10px rgba(0, 0, 0, 0.5)"
      _hover={{ 
        boxShadow: "0 20px 40px -10px rgba(0, 0, 0, 0.7), 0 0 25px rgba(66, 153, 225, 0.4)",
        transform: "translateY(-2px)"
      }}
      border="1px solid"
      borderColor="whiteAlpha.200"
      style={style}
      sx={{
        "& video": {
          objectFit: "contain",
          borderRadius: "inherit"
        }
      }}
    >
      {videoUrl ? (
        <>
          {!isReady && (
            <Center 
              position="absolute" 
              top="0" 
              left="0" 
              w="100%" 
              h="100%" 
              bg="rgba(0, 0, 0, 0.6)" 
              backdropFilter="blur(8px)"
              zIndex={2}
            >
              <Box textAlign="center">
                <CobraSpinner size="xl" color="blue.400" thickness="4px" />
                <Text mt={4} color="whiteAlpha.900" fontSize="sm" fontWeight="500" letterSpacing="wide">
                  جاري تحميل الفيديو...
                </Text>
              </Box>
            </Center>
          )}
          <Box position="absolute" top="0" left="0" w="100%" h="100%" zIndex={1}>
            <ReactPlayer
              url={videoUrl}
              controls
              width="100%"
              height="100%"
              onReady={() => setIsReady(true)}
              config={{
                file: {
                  attributes: {
                    controlsList: 'nodownload'
                  }
                }
              }}
            />
          </Box>
        </>
      ) : (
        <Center height="100%" w="100%" bg="gray.900" color="whiteAlpha.600" flexDirection="column" gap={4}>
          <Icon as={FiVideoOff} boxSize={12} opacity={0.6} />
          <Text fontSize="lg" fontWeight="semibold" letterSpacing="wide">
            لا يوجد رابط للفيديو
          </Text>
        </Center>
      )}
    </MotionBox>
  );
};

VideoPlayer.propTypes = {
  src: PropTypes.string,
  video: PropTypes.object,
  style: PropTypes.object
};

export default VideoPlayer;
